/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Feature_UnlimitedInputs */

const en_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited`)
};

const es_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilimitado`)
};

const fr_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illimité`)
};

const de_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzt`)
};

const ja_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無制限`)
};

const zh_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限制`)
};

const ar_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير محدود`)
};

const id_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak Terbatas`)
};

const it_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illimitato`)
};

const ru_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безлимит`)
};

const pt_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilimitado`)
};

const ko_tier_feature_unlimited = /** @type {(inputs: Tier_Feature_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무제한`)
};

/**
* | output |
* | --- |
* | "Unlimited" |
*
* @param {Tier_Feature_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_feature_unlimited = /** @type {((inputs?: Tier_Feature_UnlimitedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Feature_UnlimitedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_feature_unlimited(inputs)
	if (locale === "es") return es_tier_feature_unlimited(inputs)
	if (locale === "fr") return fr_tier_feature_unlimited(inputs)
	if (locale === "de") return de_tier_feature_unlimited(inputs)
	if (locale === "ja") return ja_tier_feature_unlimited(inputs)
	if (locale === "zh") return zh_tier_feature_unlimited(inputs)
	if (locale === "ar") return ar_tier_feature_unlimited(inputs)
	if (locale === "id") return id_tier_feature_unlimited(inputs)
	if (locale === "it") return it_tier_feature_unlimited(inputs)
	if (locale === "ru") return ru_tier_feature_unlimited(inputs)
	if (locale === "pt") return pt_tier_feature_unlimited(inputs)
	return ko_tier_feature_unlimited(inputs)
});